import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getApiUrl } from "../../config/api";

const SimpleCart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  console.log("🚀 SIMPLE CART: Component rendering");

  useEffect(() => {
    console.log("🚀 SIMPLE CART: useEffect triggered");
    loadCart();
  }, []);

  const loadCart = async () => {
    console.log("🚀 SIMPLE CART: loadCart function called");
    setLoading(true);
    setError(null);
    
    try {
      const userId = "68ded148cbfe892dc87f3c45";
      const apiUrl = getApiUrl(`/cart/${userId}`);
      
      console.log("🚀 SIMPLE CART: Making API call to:", apiUrl);
      console.log("🚀 SIMPLE CART: BASE_URL from config:", process.env.REACT_APP_API_URL || 'http://localhost:5000');
      
      const response = await fetch(apiUrl);
      console.log("🚀 SIMPLE CART: Response status:", response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log("🚀 SIMPLE CART: API response:", data);
        
        if (data?.items && data.items.length > 0) {
          const items = data.items.map((item) => ({
            _id: item.product._id,
            name: item.product.name,
            quantity: item.quantity,
            realTimeTotalPrice: item.realTimeTotalPrice,
            coverImage: item.product.coverImage,
            price: item.product.price,
            ...item.product
          }));
          
          console.log("🚀 SIMPLE CART: Setting cart items:", items);
          setCartItems(items);
        } else {
          console.log("🚀 SIMPLE CART: No items in response");
          setCartItems([]);
        }
      } else {
        const errorText = await response.text();
        console.error("🚀 SIMPLE CART: API error:", response.status, errorText);
        setError(`API Error: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      console.error("🚀 SIMPLE CART: Network error:", error);
      setError(`Network Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleQuantityChange = async (productId, change) => {
    console.log("🚀 SIMPLE CART: handleQuantityChange called", productId, change);
    setUpdating(true);
    
    try {
      const userId = "68ded148cbfe892dc87f3c45";
      
      if (change === -1) {
        const response = await fetch(getApiUrl('/cart/remove-from-cart'), {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId, productId })
        });
        
        if (response.ok) {
          console.log("🚀 SIMPLE CART: Item removed successfully");
          await loadCart();
        }
      } else {
        const response = await fetch(getApiUrl('/cart/add-to-cart'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId, productId, quantity: change })
        });
        
        if (response.ok) {
          console.log("🚀 SIMPLE CART: Item added successfully");
          await loadCart();
        }
      }
    } catch (error) {
      console.error("🚀 SIMPLE CART: Error updating quantity:", error);
      setError("Failed to update cart");
    } finally {
      setUpdating(false);
    }
  };

  const handleRemoveItem = async (productId) => {
    console.log("🚀 SIMPLE CART: handleRemoveItem called", productId);
    setUpdating(true);
    
    try {
      const userId = "68ded148cbfe892dc87f3c45";
      const response = await fetch(getApiUrl('/cart/remove-from-cart'), {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, productId })
      });
      
      if (response.ok) {
        console.log("🚀 SIMPLE CART: Item removed successfully");
        await loadCart();
      }
    } catch (error) {
      console.error("🚀 SIMPLE CART: Error removing item:", error);
      setError("Failed to remove item");
    } finally {
      setUpdating(false);
    }
  };

  const getSubtotal = () => {
    return cartItems.reduce((total, item) => {
      const price = Number(item.realTimeTotalPrice) || 0;
      return total + price;
    }, 0);
  };

  const calculateTotals = () => {
    const subtotal = getSubtotal();
    const tax = Math.round(subtotal * 0.03);
    const shipping = subtotal > 5000 ? 0 : 50;
    const discount = 0;
    const total = subtotal + tax + shipping - discount;

    return {
      subtotal,
      tax,
      shipping,
      discount,
      total,
    };
  };

  const totals = calculateTotals();

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#dc2626', 
        color: 'white', 
        padding: '20px',
        fontSize: '24px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '50px', 
            height: '50px', 
            border: '3px solid white', 
            borderTop: '3px solid transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p>🚀 SIMPLE CART IS LOADING...</p>
          <p style={{ fontSize: '16px' }}>Fetching your cart items...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f3f4f6', 
        color: '#dc2626', 
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>❌ Error Loading Cart</h2>
          <p style={{ fontSize: '18px', marginBottom: '20px' }}>{error}</p>
          <button 
            onClick={loadCart}
            style={{
              padding: '12px 24px',
              backgroundColor: '#f59e0b',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            🔄 Retry
          </button>
        </div>
      </div>
    );
  }

  if (cartItems.length === 0) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f3f4f6', 
        color: '#374151', 
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '20px' }}>🛒 Your cart is empty!</h2>
          <p style={{ fontSize: '18px', marginBottom: '30px' }}>Looks like you haven't added anything to your cart yet.</p>
          <Link to="/productlist">
            <button style={{
              padding: '16px 32px',
              backgroundColor: '#f97316',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '18px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              🛍️ Start Shopping
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#faf7f2', 
      padding: '20px' 
    }}>
      <div style={{ 
        backgroundColor: '#3b82f6', 
        color: 'white', 
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '28px', marginBottom: '10px' }}>🚀 SIMPLE CART COMPONENT</h1>
        <p style={{ fontSize: '16px' }}>This is the new simple cart component - {cartItems.length} Items</p>
        <p style={{ fontSize: '14px' }}>Loaded at: {new Date().toLocaleTimeString()}</p>
      </div>

      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px'
      }}>
        <h1 style={{ fontSize: '24px', marginBottom: '20px', color: '#1f2937' }}>🛒 Shopping Cart</h1>
        
        {updating && (
          <div style={{ 
            backgroundColor: '#fef3c7',
            border: '1px solid #f59e0b',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            color: '#92400e'
          }}>
            <p>🔄 Updating cart...</p>
          </div>
        )}
        
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            border: '1px solid #e5e7eb'
          }}>
            <thead style={{ backgroundColor: '#784421', color: 'white' }}>
              <tr>
                <th style={{ padding: '12px', textAlign: 'left' }}>Product</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Price</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Quantity</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Subtotal</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                  <td style={{ padding: '12px', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img
                      src={
                        item.images?.[0] ||
                        item.coverImage ||
                        "https://via.placeholder.com/50"
                      }
                      alt={item.name}
                      style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '4px' }}
                    />
                    <span style={{ fontWeight: 'bold', color: '#1f2937' }}>{item.name}</span>
                  </td>
                  <td style={{ padding: '12px', color: '#1f2937' }}>
                    ₹{(item.realTimeTotalPrice / item.quantity).toFixed(2)}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      border: '1px solid #d1d5db',
                      borderRadius: '9999px',
                      width: 'fit-content',
                      overflow: 'hidden'
                    }}>
                      <button
                        onClick={() => handleQuantityChange(item._id, -1)}
                        disabled={updating}
                        style={{
                          padding: '8px 12px',
                          backgroundColor: '#e5e7eb',
                          border: 'none',
                          cursor: updating ? 'not-allowed' : 'pointer',
                          opacity: updating ? 0.5 : 1
                        }}
                      >
                        -
                      </button>
                      <span style={{ padding: '0 16px', fontSize: '18px', color: '#1f2937' }}>{item.quantity}</span>
                      <button
                        onClick={() => handleQuantityChange(item._id, 1)}
                        disabled={updating}
                        style={{
                          padding: '8px 12px',
                          backgroundColor: '#e5e7eb',
                          border: 'none',
                          cursor: updating ? 'not-allowed' : 'pointer',
                          opacity: updating ? 0.5 : 1
                        }}
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td style={{ padding: '12px', color: '#1f2937', fontWeight: 'bold' }}>
                    ₹{item.realTimeTotalPrice.toFixed(2)}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <button
                      onClick={() => handleRemoveItem(item._id)}
                      disabled={updating}
                      style={{
                        padding: '8px 12px',
                        backgroundColor: '#dc2626',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: updating ? 'not-allowed' : 'pointer',
                        opacity: updating ? 0.5 : 1
                      }}
                    >
                      🗑️ Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        marginBottom: '20px'
      }}>
        <div style={{ 
          width: '100%',
          maxWidth: '400px',
          backgroundColor: 'white', 
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ fontSize: '20px', marginBottom: '16px', color: '#1f2937' }}>📊 Order Summary</h2>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Subtotal:</span>
              <span>₹{totals.subtotal.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Tax (3%):</span>
              <span>₹{totals.tax.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Shipping:</span>
              <span>₹{totals.shipping.toFixed(2)}</span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              fontWeight: 'bold', 
              fontSize: '18px',
              borderTop: '2px solid #e5e7eb',
              paddingTop: '8px',
              marginTop: '8px',
              color: '#1f2937'
            }}>
              <span>Total:</span>
              <span>₹{totals.total.toFixed(2)}</span>
            </div>
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Link
              to="/checkout"
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'center',
                backgroundColor: '#f59e0b',
                color: 'white',
                padding: '12px',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              💳 Proceed to Checkout
            </Link>
            
            <button
              onClick={loadCart}
              disabled={updating}
              style={{
                width: '100%',
                backgroundColor: '#6b7280',
                color: 'white',
                padding: '8px',
                borderRadius: '6px',
                border: 'none',
                cursor: updating ? 'not-allowed' : 'pointer',
                opacity: updating ? 0.5 : 1,
                fontWeight: 'bold'
              }}
            >
              🔄 Update Cart
            </button>
            
            <Link
              to="/shop"
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'center',
                backgroundColor: '#3b82f6',
                color: 'white',
                padding: '8px',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              🛍️ Continue Shopping
            </Link>
          </div>
        </div>
      </div>

      <div style={{ 
        backgroundColor: '#f3f4f6',
        padding: '16px',
        borderRadius: '8px'
      }}>
        <h3 style={{ fontWeight: 'bold', marginBottom: '8px', color: '#1f2937' }}>🔍 Debug Info:</h3>
        <p><strong>Items Found:</strong> {cartItems.length}</p>
        <p><strong>Total Value:</strong> ₹{cartItems.reduce((sum, item) => sum + parseFloat(item.realTimeTotalPrice), 0).toFixed(2)}</p>
        <p><strong>Last Updated:</strong> {new Date().toLocaleTimeString()}</p>
      </div>
    </div>
  );
};

export default SimpleCart;